export default __webpack_public_path__ + "static/media/juneshine-logo-text.6a1c5fc8.png";